import { render, staticRenderFns } from "./SenAnswerAppendButton.vue?vue&type=template&id=f774d002&scoped=true&"
import script from "./SenAnswerAppendButton.vue?vue&type=script&lang=js&"
export * from "./SenAnswerAppendButton.vue?vue&type=script&lang=js&"
import style0 from "./SenAnswerAppendButton.vue?vue&type=style&index=0&id=f774d002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f774d002",
  null
  
)

export default component.exports